<script lang="ts">
    import { Button } from "svelte-email";
    import { page } from "$app/stores";
    import { goto } from "$app/navigation";
    import { focusForm } from "$lib/stores/store";
    export let title = "title";
    export let text = "description";
    export let button = "button";
    export let isLight = true;
    export let titleFont = "text-secondary-500";
    export let btnColor = "variant-filled-tertiary";

    function handleClick() {
        // if form is on page scroll to it, otherwise go to order page
        const formField = document.querySelector(".form-container");

        if (formField) {
            formField.scrollIntoView({ behavior: "smooth", block: "center" });
            $focusForm = true;
            console.log("focusForm: ", $focusForm);
            // formField.focus();
        } else {
            goto("/order");
        }
    }
</script>

{#if isLight}
    <div class="w-full cta">
        <h2 class="text-3xl font-bold {titleFont}">{title}</h2>
        <p class="text-white">{text}</p>
        <button class="btn btn-md {btnColor} text-white" on:click={handleClick}>{button}</button>
    </div>
{:else}
    <div class="w-full cta">
        <h2 class="text-3xl font-bold {titleFont}">{title}</h2>
        <p class="text-primary-500 font-light">{text}</p>
        <button class="btn tracking-wide btn-lg {btnColor} text-white" on:click={handleClick}>{button}</button>
    </div>
{/if}

<style>
    .cta {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 2rem;
        margin-bottom: 0;
    }
    h2 {
        font-family: "Inter", sans-serif;
        font-weight: 800;
        font-size: 40px;
        line-height: 45px;
    }
    p {
        font-size: 20px;
        font-weight: 500;
        line-height: 24px;
        letter-spacing: 0.5px;
    }
    button {
        width: 100%;
        height: 50px;
        font-size: 20px;
        font-weight: 700;
        transition: all 0.3s ease-in-out;

        &:hover {
            transform: scale(1.05);
        }
    }
    @media screen and (min-width: 768px) {
        button {
            max-width: 360px;
        }
    }
</style>
